var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgbox"},[_c('img',{staticClass:"imgUrl",attrs:{"src":require("@/assets/images/404@2x.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("该链接已失效")])])
}]

export { render, staticRenderFns }